import { createStore, combineReducers, applyMiddleware } from 'redux'
import { thunk } from 'redux-thunk'
import { composeWithDevTools } from '@redux-devtools/extension'
import { detailsProductReducers, listProductReducers, listPaidCustomerReducers, detailsCustomerReducers, updateCustomerReducers, listCategoryReducers, listPostCustomerReducers } from './reducers/productReducers'
import { cartReducer } from './reducers/cartReducers'
import { userLoginReducer, userRegisterReducer, userDetailsReducer, userUpdateProfileReducer } from './reducers/userReducers'
import { orderCreateReducer, orderDetailsReducer, orderListMyReducer } from './reducers/orderReducers'
import { listCertificateReducers } from './reducers/certificateReducers'
import { listLogoReducers } from './reducers/logoReducers'
import { listPasargadInquiryReducers, listPasargadreportReducers } from './reducers/pasargadreportReducers'


const reducer = combineReducers({
    listProduct: listProductReducers,
    listCategory:listCategoryReducers,
    listLogoImage:listLogoReducers,
    listCertificate:listCertificateReducers,
    listPaidCustomer:listPaidCustomerReducers,
    listPostCustomer:listPostCustomerReducers,
    productDetails: detailsProductReducers,
    customerDetails: detailsCustomerReducers,
    cart: cartReducer,
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer,
    orderCreate:orderCreateReducer,
    orderDetails:orderDetailsReducer,
    orderListMy:orderListMyReducer,
    updateCustomer:updateCustomerReducers,
    pasargadReport:listPasargadreportReducers,
    pasargadInquiry:listPasargadInquiryReducers,

})
//برای اینکه بعدا این اطلاعات در مرورگر کاربر بماند از این قسمت استفاده میکنیمinitialstate
const cartFromLocalStorage = localStorage.getItem('cartItems') ?
    JSON.parse(localStorage.getItem('cartItems')) : []

const userInfoFromLocalStorage = localStorage.getItem('userInfo') ?
    JSON.parse(localStorage.getItem('userInfo')) : null

const paymentMethodFromLocalStorage = localStorage.getItem('paymentMethod') ?
    JSON.parse(localStorage.getItem('paymentMethod')) : {}

const ShippingAddressFromLocalStorage = localStorage.getItem('shippingAddress') ?
    JSON.parse(localStorage.getItem('shippingAddress')) : {}

const initialState = {
    cart: {
        cartItems: cartFromLocalStorage,
        shippingAddress: ShippingAddressFromLocalStorage,
        paymentMethod: paymentMethodFromLocalStorage
    },
    userLogin: { userInfo: userInfoFromLocalStorage }
}

const middleware = [thunk]

const store = createStore(reducer, initialState,
    composeWithDevTools(applyMiddleware(...middleware)))


export default store

